// extracted by mini-css-extract-plugin
module.exports = {"container":"index-modulecontainer-pJb7T","placeholder":"index-moduleplaceholder-9hf4m"};